import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import EncounterCard from "../components/EncounterCard";
import { BookOpen, Sparkles } from "lucide-react";

const Encounters = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const res = await client.get("/encounters");
      setItems(res.data.encounters || []);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const onDelete = async (enc) => {
    if (!window.confirm("Apagar este registo? Não pode ser desfeito.")) return;
    try {
      await client.delete(`/encounters/${enc.id}`);
      setItems((xs) => xs.filter((x) => x.id !== enc.id));
    } catch { /* noop */ }
  };

  return (
    <div className="min-h-screen bg-[#0C0E12]" data-testid="encounters-page">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-10">
        <div className="flex items-center gap-2">
          <BookOpen className="w-4 h-4 text-[#C5A880]" />
          <span className="label-uppercase">Diário de encontros</span>
        </div>
        <h1 className="font-display text-3xl md:text-5xl mt-3 mb-2">As tuas memórias</h1>
        <p className="text-[#A29F9B] mb-10 max-w-2xl">
          Regista o que aconteceu em cada encontro — o lugar, o humor, o que te marcou.
          Escolhe se guardas só para ti ou partilhas com a pessoa. Para registar, abre o perfil de uma ligação mútua.
        </p>

        {loading && <div className="text-[#A29F9B]">A carregar...</div>}

        {!loading && items.length === 0 && (
          <div className="bg-[#161920] border border-white/5 rounded-2xl p-12 text-center" data-testid="encounters-empty">
            <Sparkles className="w-8 h-8 text-[#C5A880] mx-auto mb-4" />
            <h3 className="font-display text-2xl mb-2">Ainda sem memórias registadas</h3>
            <p className="text-[#A29F9B] mb-6">Vai ao perfil de uma ligação mútua e toca em "Registar encontro".</p>
            <Link to="/matches" className="btn-primary inline-block" data-testid="encounters-go-matches">Ver ligações</Link>
          </div>
        )}

        {!loading && items.length > 0 && (
          <div className="space-y-5" data-testid="encounters-list">
            {items.map((e) => (
              <EncounterCard key={e.id} encounter={e} showPartnerHeader onDelete={onDelete}
                onEdit={() => {
                  // From the global timeline we redirect to the partner's profile with a deep-link param.
                  if (e.partner) window.location.href = `/profile/${e.partner.id}?edit_encounter=${e.id}`;
                }} />
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Encounters;
